<template>
	<div>
		<HeaderSection icon="fa-chart-bar" title="Estadísticas">
		    <template slot="buttons">
				<el-button
						size="medium"
						type="danger"
						icon="el-icon-arrow-left"
						@click="goToIndex">
					Regresar
				</el-button>
			</template>
		</HeaderSection>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<i class="fas fa-filter"></i>
				<span> Filtros</span>
			</div>
			<filters></filters>
			<el-row style="margin-top: 1em">
				<el-col align="right">
					<el-button
						size="medium"
						type="primary"
						@click="applyFilters(requestFilters)">
						<i class="fas fa-filter"></i>
						Filtrar
					</el-button>
				</el-col>
			</el-row>
		</el-card>
		<br>
		<el-dialog
                :fullscreen="true"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title="Estadísticas"
                :visible.sync="modalStats">
            <bar-chart 
            	v-if="chartData && modalStats && !subBudget"
				:chart-data="chartData"
				:options="{
					scales: {
					    xAxes: [{
					        stacked: false,
					        beginAtZero: true,
					        ticks: {
					        	minRotation: 90,
					            autoSkip: true,
					            autoSkipPadding: 10
					        }
					    }]
					},
					responsive: true, 
					maintainAspectRatio: false
				}"
				align="center"
				:height="(requestFilters.checkList[1] == 'cat_office_id' && 
						(requestFilters.cat_office_id == null ||
						requestFilters.cat_office_id == '')) ? 1000 : false"
				:width="2000">
			</bar-chart>
			<pie-chart 
            	v-if="chartData && modalStats && subBudget"
				:chart-data="chartData"
				:options="{responsive: true, 
							maintainAspectRatio: false}"
				align="center">
			</pie-chart>
			<el-row style="margin-top: 1em">
				<el-col align="right">
					<!-- <el-button
						size="medium"
						type="primary"
						@click="modalStats = !modalStats">
						<i class="fas fa-filter"></i>
						Cambiar filtros
					</el-button> -->
					<el-tooltip class="item" effect="dark" 
			    		v-if="chartData.datasets"
						content="Descargar contenido en formato excel" 
	                    placement="top">
						<el-button
							size="medium"
							type="success"
							@click.prevent="downloadFile"
							icon="fas fa-file-excel">
							Descargar
						</el-button>
					</el-tooltip>
					<el-button
						v-if="chartData.datasets"
						size="medium"
						type="danger"
						@click="download2PNG(activeChart)">
						<i class="fas fa-file-image"></i>
						Descargar gráfica
					</el-button>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
	import HeaderSection from '@/components/partials/HeaderSection';
	import Filters from '@/components/views/admin/statistic/partials/Filters'
	/*import Charts from '@/components/views/admin/statistic/partials/Charts'*/
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
	import BarChart from '@/components/views/admin/statistic/partials/Chart.js';
	import PieChart from '@/components/views/admin/statistic/partials/PieChart.js';

	export default {
		components:{
			HeaderSection,
			Filters,
			BarChart,
			PieChart
		},
		computed: {
			...mapGetters("statistic", {
				requestFilters: "requestFilters",
				catalogs: "catalogs",
			}),
		},
		data(){
			return{
				modalStats: false,
				subBudget: false,
				chartData:[],
				activeChart: ''
			}
		},
		mounted(){
			this.initService();
		},
		methods:{
			...mapActions('statistic', {
				initService: "initService"
			}),
			showLoading(message) {
				this.$store.dispatch(
					"loading/spinner",
					{msg: message, status: true},
					{root: true}
				);
			},
			hideLoading() {
				this.$store.dispatch("loading/spinner", {}, {root: true});
			},
			goToIndex(){
				this.$router.push('/administracion');
			},
			applyFilters(filters){
				
				this.showLoading("Generando gráfica...");
				axios.get('/api/acquisitions/acquisitions-stats', { params: {filters} })
				.then(response => {
					this.hideLoading();
					this.chartData = [];
					if (response.data.success) {
						let info = response.data.acquisitions;
						if (Array.isArray(info)) {
							this.activeChart = 'bar-chart';
							this.subBudget = false;
							this.modalStats = true;
							const color = this.getRandomColor();
							var objectBar = {
								label: 'Total de solicitudes',
								borderColor: color,
								backgroundColor: color,
								pointBackgroundColor: 'white',
								pointBorderColor: 'white',
								borderWidth: 2,
								data: [info.length, 0]
					        }
					        this.chartData.labels = ['Nº Solicitudes'];
					        this.chartData.datasets = [objectBar];

						}else{
							this.modalStats = true;
							this.subBudget = false;
							this.activeChart = 'bar-chart';
					        var arrayFinal = [];
					        if(filters.checkList.length > 1){

					        	/*if(filters.checkList[0] === "sub_budget_id" || 
						        	filters.checkList[1] === "sub_budget_id" ||
						        	filters.sub_budget_id !== null){
						        	this.subBudget = true;
						        }else{
						        	this.subBudget = false;
						        }*/

					        	var mainCols = this.getColumnsCats(filters.checkList[0]);
					        	var secCols = this.getColumnsCats(filters.checkList[1]);
					        	var barra = { 
					        		label: '', 
					        		data: [],
									pointBackgroundColor: 'white',
									pointBorderColor: 'white',
									borderWidth: 2, 
								};
					        	var labels = [];

					        	Object.entries(filters).forEach((filter) => {
					        		if((filter[1] !== null && filter[1] !== ""))
					        		{
					        			if(filters.checkList[0] === filter[0]){
					        				mainCols = mainCols.filter(col => col.id === filter[1]);
					        			}
					        			if(filters.checkList[1] === filter[0]){
					        				secCols = secCols.filter(col => col.id === filter[1]);
					        			}
					        		}
					        	});

					        	mainCols.forEach((cat)=>{
					        		if(filters.checkList[0] === 'cat_office_id'){
					        			labels.push(cat.representation_name);
					        		}else{
					        			labels.push(cat.name);
					        		}
					        	});

					        	var collect = [];
				        		Object.values(info).forEach((element, index) => {
					        		Object.values(element).forEach((item)=>{
					        			Object.values(item).forEach((data) => {
					        				collect.push(data);
					        			});
					        		});
					        	});

								secCols.forEach((scat)=>{
									var r = collect.filter(x => 
										x[filters.checkList[1]] == scat.id);

									barra = { 
										id: scat.id,
										label: scat.name, 
										data: [],
										pointBackgroundColor: 'white',
										pointBorderColor: 'white',
										borderWidth: 2, 
									};
									if(filters.checkList[1] === 'cat_office_id'){
										barra.label = scat.representation_name;
									}else{
										barra.label = scat.name;
									}
									mainCols.forEach((cat)=>{
										var rr = r.filter(x => 
											x[filters.checkList[0]] == cat.id);
										const color = this.getRandomColor();
										//barra.data.push(rr.length);

										var total = 0;
										//Validación a nivel de la cantidad de articulos
										if(filters.checkList[0] == 'product_or_service_id')
										{
											r.forEach((request) => {
												if(request.articles.length > 0){
													var arts = request.articles.filter(o => 
														o.article_id == cat.id);
													var amounts = arts.map(o => o.amount);
													if(amounts.length > 0){
														total = total + amounts.reduce(
														function(a, b){ return a + b; });
													}
												}
											});
										}

										//Validación a nivel de la cantidad de articulos
										if(filters.checkList[1] == 'product_or_service_id')
										{
											collect.forEach((request) => {
												if(request.articles.length > 0){
													//bar.label = 'Nº Solicitudes o Cantidad de articulos';
													var arts = request.articles.filter(o => 
														o.article_id == scat.id);
													var amounts = arts.map(o => o.amount);
													if(amounts.length > 0 && cat.id == request[filters.checkList[0]]){
														total = total + amounts.reduce(
														function(a, b){ return a + b; });
														//bar.data.push(total);
													}
												}
											});
										}

										if(total > 0){
											barra.data.push(total);
										}else{
											barra.data.push(rr.length);
										}


										barra.borderColor = color;
										barra.backgroundColor = color;
									});
									barra.data.push(0);
									arrayFinal.push(barra);
								});
					        	
					        	this.chartData.datasets = arrayFinal;
					        	this.chartData.labels = labels;

					        }else if(filters.checkList.length === 1){

					        	if(filters.checkList[0] === "sub_budget_id" /*|| 
						        	filters.sub_budget_id !== null*/){
					        		this.activeChart = 'pie-chart';
						        	this.subBudget = true;
						        }else{
						        	this.subBudget = false;
						        	this.activeChart = 'bar-chart';
						        }

					        	var bar = { 
					        		label: '', 
					        		data: [],
					        		pointBackgroundColor: 'white',
									pointBorderColor: 'white',
									borderWidth: 2, 
									borderColor: [],
									backgroundColor: []
					        	};
					        	var collect = [];
					        	var mainCols = this.getColumnsCats(filters.checkList[0]);

					        	bar.label = this.setLabelGroupName(filters.checkList[0]);
					        	Object.entries(filters).forEach((filter) => {
					        		if((filter[1] !== null && filter[1] !== "") 
					        			&& filter[0] !== "checkList" 
					        			&& filter[0] !== "period" )
					        		{
					        			var filterCat = this.getColumnsCats(filter[0]);
					        			filterCat.forEach((cat)=>{
					        				if(cat.id === filter[1]){
					        					if(filter[0] === 'cat_office_id'){
								        			var text = cat.representation_name;
								        			bar.label += ' - '+ text;
								        		}else{
								        			bar.label += ' - '+cat.name;
								        		}
					        					
					        				}
					        			});

					        			if(filters.checkList[0] === filter[0]){
					        				mainCols = mainCols.filter(col => col.id === filter[1]);
					        			}
					        		}
					        	});

					        	var labels = [];
					        	mainCols.forEach((cat)=>{
					        		if(filters.checkList[0] === 'cat_office_id'){
					        			labels.push(cat.representation_name);
					        		}else{
					        			labels.push(cat.name);
					        		}
					        	});

					        	Object.values(info).forEach((element) => {
					        		Object.values(element).forEach((data)=>{
					        			collect.push(data);
					        		})
					        	});
					        	
								if(filters.checkList[0] == 'product_or_service_id')
								{
									mainCols.forEach((cat)=>{
										var result = collect.filter(x => 
											x[filters.checkList[0]] == cat.id);
										var total = 0;
										collect.forEach((request) => {
											if(request.articles.length > 0){
												var arts = request.articles.filter(o => 
													o.article_id == cat.id);
												var amounts = arts.map(o => o.amount);
												if(amounts.length > 0){
													total = total + amounts.reduce(
													function(a, b){ return a + b; });
												}
											}
										});
										if(total > 0){
											bar.data.push(total);
										}else{
											bar.data.push(result.length);
										}

										const color = this.getRandomColor();
										bar.borderColor.push(color);
										bar.backgroundColor.push(color);
									});
								}else{
									mainCols.forEach((cat)=>{
										var result = collect.filter(x => 
											x[filters.checkList[0]] == cat.id);

										bar.data.push(result.length);
										const color = this.getRandomColor();
										bar.borderColor.push(color);
										bar.backgroundColor.push(color);
									});
								}

					        	bar.data.push(0);
					        	this.chartData.datasets = [bar];
					        	this.chartData.labels = labels;
					        }
						}
					}
					else {
						this.$store.dispatch('notifications/error', 
							{msg: 'Error en la consulta.'}, {root: true});

					}
				}).catch(error => {
					this.hideLoading();
					console.log(error);
					this.$store.dispatch('notifications/error', 
						{msg: 'No se pudo completar la acción.'}, {root: true});
				});
			},
			getColumnsCats(checkList){
				if(checkList == 'cat_office_id'){
					return this.catalogs.catOffice;
				}
				if(checkList == 'cat_acquisition_type_id'){
					return this.catalogs.catAcquisitionType;
				}
				if(checkList == 'sub_budget_id'){
					return this.catalogs.catSubBudget;
				}
				if(checkList == 'product_or_service_id'){
					return this.catalogs.catProductsOrServicesArticles;
				}
			},
			getRandomColor() {
                var letters = 'BCDEF'.split('');
                var color = '#';
                for (var i = 0; i < 6; i++ ) {
                    color += letters[Math.floor(Math.random() * letters.length)];
                }
                return color;
            },
            setLabelGroupName(cat){
            	if(cat == 'cat_office_id'){
            		return "Representación";
            	}
            	if(cat == 'cat_acquisition_type_id'){
            		return "Tipo de adquisición";
            	}
            	if(cat == 'sub_budget_id'){
            		return "Subpartida";
            	}
            	if(cat == 'product_or_service_id'){
            		return "Productos o Servicios";
            	}
            },
            downloadFile(){
                var url = '/api/acquisitions/acquisitions-excel-stats';
                this.getFileUrl(url);
            },
            getFileUrl(url) {
                let _this = this;
                _this.showLoading('Descargando documento...');

                let filters = this.requestFilters;

                axios.get(url, {responseType: 'blob', params : {filters} })
                .then(response => {
                    let now = new Date().toLocaleDateString(); 
                    const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = linkUrl;

                    link.setAttribute('download', 'estadisticas_adquisiciones' + ' - ' + now + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    _this.hideLoading();
                    _this.$notify({
			          title: 'Éxito',
			          message: 'Fue generado el reporte en excel',
			          type: 'success'
			        });
                })
                .catch(error => {
                    _this.hideLoading();
                    _this.$notify({
			          title: 'Error',
			          message: 'No fue posible realizar la descarga, inténtelo nuevamente.',
			          type: 'warning'
			        });
                });
            },
            download2PNG(chart){
            	let now = new Date().toLocaleDateString(); 
            	let canvas = document.getElementById(chart).toDataURL('image/png')
		        let link = document.createElement('a')
		        link.setAttribute('download', 'estadisticas_adquisiciones' + ' - ' + now + '.png');
		        //link.download = 'image'
		        link.href = canvas
		        link.click()
            }
		}
	}
</script>

<style scoped>

</style>